<template>
  <div>
    <v-card outlined>
      <v-card-title>
        <v-icon color="primary">mdi-home-group</v-icon>
        <span class="ml-2 text-subtitle-2">Danh sách lớp học</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="mappedItems"
          disable-sort
          :loading="loading"
          item-key="id"
          loading-text="Đang Tải"
          mobile-breakpoint="0"
          no-data-text="Không có dữ liệu"
          :footer-props="{
            'items-per-page-text': 'Số dòng mỗi trang'
          }"
        >
          <template v-slot:[`item.grade`]="{ item }">
            <router-link v-if="item.grade" style="text-decoration: none; white-space: nowrap;" :to="'/grades/' + item.grade.id">
              {{ item.grade.title }}
            </router-link>
            <span v-else>-</span>
          </template>
          <template v-slot:[`item.class`]="{ item }">
            <router-link v-if="item.id" style="text-decoration: none; white-space: nowrap;" :to="'/class/' + item.id">
              {{ item.title }}
            </router-link>
            <span v-else>{{ item.title }}</span>
          </template>
          <template v-slot:[`item.beginningDate`]="{ item }">
            {{ moment(item.beginningDate).format('DD-MM-YYYY') }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <DivisionActions :selected="item" />
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip small class="white--text" v-if="item.status" :color="item.status | classStatusColor" label>
              {{ item.status | classStatus }}
            </v-chip>
          </template>
          <template v-slot:[`item.absent`]="{ item }">
            {{ item.absent }}
          </template>
          <template v-slot:[`item.attended`]="{ item }">
            {{ item.attended }}
          </template>
          <template v-slot:[`item.rate`]="{ item }">
            {{ item.attended }} / {{ item.total }} ({{ Number(item.rate).toFixed(2) }}%)
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn v-if="item.student" class="elevation-0" icon @click="() => openDialog(item)">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <report-learning-dialog ref="report-learning-dialog"></report-learning-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapMutations, mapState } from 'vuex'
import ReportLearningDialog from '@/modules/student/report/ReportLearningDialog'

export default {
  components: {
    ReportLearningDialog,
  },
  props: {
    classData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      moment,
      items: [],
      loading: false,
      headers: [
        { text: 'STT', value: 'index', align: 'center' },
        { text: 'Học phần', value: 'grade' },
        { text: 'Lớp', value: 'class' },
        { text: 'Ngày bắt đầu', align: 'left', value: 'beginningDate' },
        { text: 'Trạng thái', align: 'left', value: 'status' },
        { text: 'Số buổi vắng', value: 'absent', align: 'center', sortable: false },
        { text: 'Số buổi có mặt', value: 'attended', align: 'center', sortable: false },
        { text: 'Tỉ lệ', value: 'rate', align: 'center', sortable: false },
        { text: 'Thao tác', value: 'action', width: 100, sortable: false, align: 'center' },
      ],
    }
  },
  computed: {
    ...mapState('lessonAttendance', ['statsAttendance']),
    mappedItems() {
      return this.items.map((item) => {
        const attendanceData = this.statsAttendance.find((stat) => stat.class.id === item.id) || {}
        return {
          ...item,
          absent: attendanceData.absent || 0,
          attended: attendanceData.attended || 0,
          total: attendanceData.total || 0,
          rate: attendanceData.rate || '0',
          student: attendanceData.student || null,
        }
      })
    },
  },
  watch: {
    classData: {
      handler(val) {
        if (val) {
          this.items = val.filter((v) => v.type === 'coreCurriculum').map((v, index) => ({ ...v, index: index + 1 }))
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.fetchAttendanceData()
  },
  methods: {
    ...mapActions({
      findStatsAttendance: 'lessonAttendance/findStatsAttendance',
    }),
    ...mapMutations({
      setStatsAttendance: 'lessonAttendance/setStatsAttendance',
    }),
    openDialog(item) {
      this.$refs['report-learning-dialog'].openDialog({ class: item, student: item.student })
    },
    async fetchAttendanceData() {
      try {
        this.setStatsAttendance([])
        this.loading = true
        await this.findStatsAttendance({ student: this.$route.params.id })
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
